
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
    name: ''
})
export default class extends Vue {
    @Prop({ default: () => [] }) private interviews!: any[]
}
